import PayDiscrepancyPage from "@/app/(app)/(crew)/reports/(pay-discrepancy)/index";

export default PayDiscrepancyPage;
